import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

import HomePage from "./pages/HomePage";
import FirmaPage from "./pages/FirmaPage";
import ServiciosPage from "./pages/ServiciosPage";
import ServicioDetallePage from "./pages/ServicioDetallePage";
import MisionVisionPage from "./pages/MisionVisionPage";
import ContactoPage from "./pages/ContactoPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/firma" element={<FirmaPage />} />
            <Route path="/servicios" element={<ServiciosPage />} />
            <Route path="/servicios/:slug" element={<ServicioDetallePage />} />
            <Route path="/mision-vision" element={<MisionVisionPage />} />
            <Route path="/contacto" element={<ContactoPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "Inter, sans-serif",
              border: "1px solid #E2E8F0",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;